import React from 'react';
import { withStyles } from '@material-ui/styles';

import styles from '../styles';
import CustomIconButton from '../../../partials/tableCustomButtons/CustomIconButton';
import SpecificationDialog from './SpecificationDialog';

const TableActionButtons = ({ data: order, classes, client }) => {
  return (
    <div className={classes.actionButtons}>
      <SpecificationDialog order={order} client={client}>
        <CustomIconButton
          iconTooltipIntlKey="ORDERS.SPECIFICATION"
          iconClassName="far fa-list"
        />
      </SpecificationDialog>
    </div>
  );
};

export default withStyles(styles)(TableActionButtons);
